import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { toast, Toaster } from "react-hot-toast";
import { forgetPassword } from "../../services/UserManagementServices";
import FormWrapper from "components/common/formWrapper/FormWrapper";
import TextField from "common/TextField";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
const ForgetPassword = (props) => {
  const { t } = useTranslation();
  const [buttonLoading, setButtonLoading] = useState(false);
  const validate = Yup.object({
    email: Yup.string().required(t("required")).email("Invalid Email"),
  });
  const handleSubmit = async (formik) => {
    if (formik.isValid && Object.keys(formik.touched).length > 0) {
      setButtonLoading(true);
      let result = await forgetPassword({
        email: formik?.values?.email,
      });
      if (result?.success) {
        setButtonLoading(false);
        // formik.setFieldValue("email","");
        formik.resetForm();
        toast.success(t("success-post-email"));
      } else if (result.status == 422) {
        toast.error(t("err-email-not-registered"));
        setButtonLoading(false);
      } else {
        toast.error(result?.message);
        setButtonLoading(false);
      }
    }
  };

  return (
    <FormWrapper>
      <Toaster />
      <div style={{ maxWidth: "500px" }}>
        <Formik
          initialValues={{
            email: "",
          }}
          validationSchema={validate}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <Form className="d-flex flex-column justify-content-center w-100">
              <p className="mt-5 text-center">{t("enter-regestered-email")}</p>
              <TextField type="email" name="email" />

              {/* <TextField type="password" name="retypeNewPassword" /> */}

              <button
                className="parentbtn"
                type="submit"
                onClick={() => handleSubmit(formik)}
              >
                {buttonLoading ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  t("send")
                )}
              </button>
            </Form>
          )}
        </Formik>
      </div>
    </FormWrapper>
  );
};

export default ForgetPassword;
